import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LocalStorageService } from "@services/root/local-storage.service";
import { TokenService } from '@services/rest/token.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
    selector: 'app-dashboard',
    templateUrl: './default-layout.component.html',
    styleUrls: ["default-layout.component.scss"],
    standalone: false
})
export class DefaultLayoutComponent  implements OnInit  {
  public sidebarMinimized = false;


  constructor( 
    private localStorageService: LocalStorageService,
    private tokenService: TokenService,
    private notification: NzNotificationService,
  ) {

  }

  ngOnInit(): void {
      var roles = this.tokenService.getRoles();
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  logout(){
    this.localStorageService.clearAllLocalStorage();
  }



  showNotification(message,status){
    if(status){
        this.notification.success(message,""); 
    }
    else{
        this.notification.error(message,"");
    }
  }
}
